const searchParentAndChildInterests = (keyword, interestLocationType=false) => `query searchParentAndChildInterests {
    listInterests(
      filter: {
       ${ interestLocationType ? `type: {eq: ${interestLocationType}},` : `` }
        or: [
          {parentTitle: {contains: "${keyword}"}},
          {title: {contains: "${keyword}"}}
        ]
      },
      limit: 10000
  ) {
    items {
      id
      title
      parentID
      parentTitle
      parentInterest {
        title
      }
    }
  }
}`;

export default searchParentAndChildInterests;